// API endpoints, routes, and status constants

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    PROFILE: '/auth/profile',
    VERIFY: '/auth/verify',
    RESET_PASSWORD: '/auth/reset-password',
  },
  USER: {
    ACCOUNT: '/user/account',
  },
  DEVELOPER: {
    PROFILE: '/developer/profile',
    SETTINGS: '/developer/settings',
  },
  SERVICES: {
    LIST: '/marketplace/services',
    GET: (id: string) => `/marketplace/services/${id}`,
  },
  ANALYTICS: {
    OVERVIEW: '/developer/analytics/overview',
    REVENUE: '/developer/analytics/revenue',
    USAGE: '/developer/analytics/usage',
    SUBSCRIPTIONS: '/developer/analytics/subscriptions',
    EXPORT: '/developer/analytics/export',
  },
  PAYOUTS: {
    LIST: '/developer/payouts',
    GET: (id: string) => `/developer/payouts/${id}`,
    SETTINGS: '/developer/payouts/settings',
    UPDATE_SETTINGS: '/developer/payouts/settings',
    HISTORY: '/developer/payouts/history',
  },
} as const;

// Application Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  SERVICES: '/services',
  SERVICES_CREATE: '/services/create',
  SERVICES_EDIT: (id: string) => `/services/edit/${id}`,
  ANALYTICS: '/analytics',
  ANALYTICS_REVENUE: '/analytics/revenue',
  ANALYTICS_USAGE: '/analytics/usage',
  ANALYTICS_SUBSCRIPTIONS: '/analytics/subscriptions',
  PAYOUTS: '/payouts',
  PAYOUTS_SETTINGS: '/payouts/settings',
  MY_ACCOUNT: '/my-account',
  MY_SUBSCRIPTIONS: '/my-account/subscriptions',
  MY_ACCOUNT_SUBSCRIPTIONS_USAGE: (id: string) => `/my-account/subscriptions/${id}/usage`,
  MY_ACCOUNT_SUBSCRIPTIONS_BILLING: (id: string) => `/my-account/subscriptions/${id}/billing`,
  PRIVACY: '/privacy',
  TERMS: '/terms',
  ABOUT: '/about',
  CONTACT: '/contact',
  NOT_FOUND: '/404',
} as const;

// Status Constants
export const SERVICE_STATUSES = {
  DRAFT: 'draft',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
} as const;

export const PAYOUT_STATUSES = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
} as const;

// Application Constants
export const APP_CONFIG = {
  NAME: 'AskiiMall Marketplace',
  VERSION: '1.0.0',
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    MAX_PAGE_SIZE: 100,
  },
  CACHE: {
    DEFAULT_TTL: 5 * 60 * 1000, // 5 minutes
  },
} as const;

// Validation Constants
export const VALIDATION = {
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128,
  },
  SERVICE_NAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 100,
  },
  DESCRIPTION: {
    MAX_LENGTH: 1000,
  },
} as const;
